import React from 'react';
import ReactDOM from 'react-dom';
import CartPage from './ui/page/cart-page';
import { Provider } from 'react-redux';
import store from './data/store';

/**
 * https://dev.waves.com/cart-bp
 */
const init = () => {
    const $root = document.getElementById('cart-app');
    if (!$root) return;

    ReactDOM.render(
        <Provider store={store}>
            <CartPage />
        </Provider>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {}

